import { ProductDeliveryPromiseExplanations, ProductTileVerticalFormat } from './product-detail/ProductTypes';
import { ProductLister } from './product-lister';

export type ProductGroupFredhopperState = {
  totalPages: number;
  itemCount: number;
  items: Array<ProductLister>;
  title: string;
  slogan: string;
  name: string;
  campaignType: string;
  campaignName: string;
};

export type ProductGroupFredhopperOwnProps = {
  campaign: string;
  productId?: string;
  colourId?: string;
  title?: string;
  tileFormat: ProductTileVerticalFormat;
  deliveryPromiseExplanations: ProductDeliveryPromiseExplanations;
  collapsed?: boolean;
  collapsible: boolean;
  fredHopperPageType?: string;
};
